import React from "react";
import AllBanner from "../component/sections/advertise/AllAdvertise";
import ViewBanner from "../component/sections/advertise/ViewAdvertise";

const advertiseRoutes = [
  {
    path: "/advertise/all",
    render: () => <AllBanner />,
    exact: true,
  },
  {
    path: "/advertise/:id",
    render: () => <ViewBanner />,
    exact: true,
  },
];

export default advertiseRoutes;
